export default "__VITE_ASSET__dl5kG4pb__"